<script>
import TablePage from '@/found/components/table_page';

export default {
  extends: TablePage,
  components: {
  },
  data() {
    return {
      formConfig: {},
      modalConfig: {
        title: '新增',
        visible: false,
        type: 'Modal',
      },
    };
  },
  mounted() {
    this.getConfigList('order-invoice-list');
  },
  methods: {
    modalClick({ val, row }) {
      if (val.code === 'adjustment') {
        this.modalConfig.title = '手动';
        this.formConfig.poolId = row.id;
        this.formConfig.code = 'edit';
        this.openModal();
      }
      if (val.code === 'detail') {
        this.$router.push(`/capital-pool/cash/detail?poolId=${row.id}`);
      }
    },
  },
};
</script>
